import * as ActionTypes from '../../constants/plugins/ActionTypes'
import update from 'immutability-helper'

const initialState = {
	list: []
}

export default (state = initialState, action) => {
	let index;
	switch(action.type) {
		case ActionTypes.RECEIVE_PLUGINS:
			return update(state, {
				list: {
					$set: action.plugins
				}
			})

		case ActionTypes.CHANGE_PLUGIN:
			index = state.list.findIndex(item => item.name === action.plugin.name)
			return update(state, {
				list: {
					[index]: {
						$set: action.plugin
					}
				}
			})

		default:
			return state
	}
}
